export default function Species() {
  return <div>N/A</div>;
}
